/*
Copyright 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * Functions for applying common thematic effects to  UI elements.
 * Ideally this would be themeable.
 */

import Velocity from 'velocity-vector';
import 'velocity-vector/velocity.ui';

export function field_input_incorrect(element) {
    Velocity(element, "callout.shake", 300);
}



// WEBPACK FOOTER //
// ../src/UiEffects.js